import React from "react";
import { useJobIdParam, useL1L2Params } from "../hooks/useL1L2Params";

export const JobIdManager: React.FC = () => {
  const { jobId } = useJobIdParam();

  // This is a utility component that manages L1/L2 params
  // It doesn't render anything visible, it just handles the params
  return null;
};

export default JobIdManager;
